<div class="unauthorised-page">
    <div class="unauthorised-page__image">
        <img src="assets/icons/common/error.svg" alt="Error">
    </div>
    <div class="unauthorised-page__primary-text">
        You are not authorised to access this site.
    </div>
    <div class="unauthorised-page__secondary-text">
        {{supportMessage()}}
    </div>
</div>

